import React from "react";
import { FiGlobe, FiTablet, FiCpu, FiLayers } from "react-icons/fi";
import { LuSettings, LuShield, LuPercent, LuUsers, LuSmartphone, LuShieldCheck, LuPalette, LuCode, LuRocket, LuClipboardList, LuCircleCheck, LuSearch } from "react-icons/lu";

export const IpadHeroData = {
  backgroundImage: "/images/serviceBanners/ipad.webp",
  whiteImage: "/images/serviceBanners/IpadW.webp",
  subTitle: "iPad App Development Services",
  title: (
    <>
      Expansive <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">iPad App Development</span>
    </>
  ),
  description:
    "We build high performance iPad applications using Apple iPadOS ecosystem to deliver smooth, optimized, and scalable tablet experiences with enhanced usability, performance, and seamless user interaction for businesses.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("iPad Quote clicked"),
  },
  secondaryButton: {
    title: "View Portfolio",
    onClick: () => console.log("iPad Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized iPad app performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Smooth and adaptive experience across all iPad screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with Apple security standards for stable performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly iPadOS code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/icons/swift_icon.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(240,81,56,0.35)",
      iconGlow: "rgba(240,81,56,0.9)",
    },
  ],
};

// 2. Stats Block
export const ipadStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const ipadSolutionsAndProcessData = {
  buildSubtitle: "OUR IPAD SERVICES",
  buildTitle: "Custom iPad App Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform iPad Support",
      desc: "Build scalable apps optimized for iPadOS with smooth device compatibility.",
      icon: FiTablet,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise iPad Solutions",
      desc: "Develop secure and high-performance apps for large-scale business operations.",
      icon: FiCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce iPad Apps",
      desc: "Create rich shopping experiences with secure payments and smooth UI.",
      icon: FiLayers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand iPad Apps",
      desc: "Build real-time booking and service-based applications for iPad users.",
      icon: FiGlobe,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech iPad Solutions",
      desc: "Develop secure financial applications with modern iPadOS experiences.",
      icon: FiTablet,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom iPad Development",
      desc: "Create tailored iPad applications based on specific business requirements.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "IPAD APP DEVELOPMENT PROCESS",
  processTitle: "iPad App Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and iPadOS-specific requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define features, tech stack, and iPad application development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create intuitive and touch-optimized iPad interface designs.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance iPad applications using Apple ecosystem.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test performance, usability, and compatibility across iPad devices.",
      icon: LuCircleCheck, // Correct Lucide icon variant to maintain compilation compliance
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch iPad app and provide continuous updates and maintenance.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR IPAD APP DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose iPad App Development Solutions",
  benefits: ["Cross-platform support", "Faster development", "Modern UI design", "Smooth performance", "Efficient workflow", "Scalable solutions", "Cost-effective development"],
  logoImage: "/images/serviceBanners/ipad.webp",
  whiteLogoImage: "/images/serviceBanners/IpadW.webp",
};

// 4. Portfolio Data
export const ipadPortfolioData = {
  subtitle: "OUR WORK",
  title: "iPad Apps Driving Performance",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "FieldFlow Pro",
      badge: "Enterprise Tool",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A logistics management tool optimized for iPad Pro with offline field synchronization.",
      downloads: "Active",
      rating: "5.0",
      image: "/images/MobileAppDevelopment/iPad-Custom.png",
    },
  ],
};

// 5. Technologies Data
export const ipadTechnologiesData = {
  techTitle: "IPADOS TOOL STACK",
  technologies: [
    { name: "Swift", icon: "Code" },
    { name: "SwiftUI", icon: "Vite" },
    { name: "Core Data", icon: "SQLite" },
    { name: "Combine", icon: "Zap" },
    { name: "ARKit", icon: "RestAPI" },
    { name: "TestFlight", icon: "Firebase" },
  ],
  trustTitle: "TRUSTED BY CORPORATIONS Worldwide",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const ipadAboutData = [
  {
    title: "iPad App Development Company for Powerful Tablet Experiences",
    content: (
      <>
        Modern businesses need applications that take full advantage of larger screens and touch-focused interactions to improve productivity and engagement. A trusted{" "}
        <b className="text-text-primary font-semibold">ipad app development company</b> helps organizations create scalable tablet applications designed for smoother workflows and
        better customer experiences. Many businesses struggle with mobile applications that fail to utilize tablet capabilities effectively. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, iPad applications are developed around business goals, usability, and performance expectations to
        help organizations create practical and future-ready digital experiences.
      </>
    ),
  },
  {
    title: "Custom iPad Application Development for Better User Engagement",
    content: (
      <>
        Tablet applications require thoughtful experiences that balance performance with intuitive navigation. Reliable{" "}
        <b className="text-text-primary font-semibold">custom ipad application development</b> helps businesses create personalized solutions that improve customer interaction and
        simplify operational workflows. Companies investing in <b className="text-text-primary font-semibold">tablet app development services</b> often benefit from stronger
        usability because applications are designed around real business requirements and user expectations. Tycho Technologies focuses on practical iPad strategies that improve
        engagement while supporting long-term scalability and operational efficiency.
      </>
    ),
  },
  {
    title: "iOS Tablet App Development for Scalable Solutions",
    content: (
      <>
        Businesses looking to improve digital accessibility often require applications that work efficiently across larger-screen environments. Reliable{" "}
        <b className="text-text-primary font-semibold">ios tablet app development</b> helps organizations create interactive experiences that improve productivity and customer
        satisfaction. Companies aiming to strengthen digital ecosystems frequently align mobile strategies with{" "}
        <a href="https://tychotechnologies.com/ott-platform-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ott app development company
        </a>{" "}
        solutions to support engaging content delivery and connected digital experiences.
      </>
    ),
  },
  {
    title: "Why Businesses Choose an iPad App Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">ipad app development company in india</b> continues to grow as businesses seek scalable tablet
        experiences for customers and internal operations. Companies investing in <b className="text-text-primary font-semibold">ipad application development services india</b>{" "}
        often prioritize usability, performance, and better digital accessibility. Businesses partnering with Tycho Technologies gain access to customized iPad solutions designed
        around measurable business objectives and user behavior. Many organizations also improve mobile flexibility through{" "}
        <a href="https://tychotechnologies.com/hybrid-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          hybrid mobile app development services
        </a>{" "}
        to create connected experiences across multiple devices.
      </>
    ),
  },
];

// 7. FAQs (Preserved)
export const ipadAppFaqs = [
  {
    q: "Why should I choose iPad app development services in India?",
    a: "iPad app development in India offers skilled and cost-effective solutions to build high-quality, custom iOS apps optimized for iPads with a focus on performance and intuitive design.",
  },
];
